import React from "react";
import { Card, List, Image, Popup } from "semantic-ui-react";
import { useDropzone } from "react-dropzone";

const CustomFileUpload = ({
  title,
  popupMessage,
  uploadedFiles,
  onRemoveFile,
  onDrop,
  allowedFileTypesMessage,
  maxFileSizeMessage,
  dropzoneStyles,
  getRootProps,
  getInputProps,
  isDragActive,
}) => {
  return (
    <Card fluid>
      <Card.Content>
        <p style={{ color: "#141834", display: "flex" }}>
          <b>{title}</b>
          <Popup
            inverted
            position="right center"
            trigger={
              <Image
                className="pdfHoverImg"
                src="/images/Info.svg"
                alt="Info"
                style={{ width: "20px", height: "20px" }}
              />
            }
            style={{ borderRadius: "15px" }}
          >
            <div>{popupMessage}</div>
          </Popup>
        </p>
      </Card.Content>
      <Card.Content extra>
        <div>
          {uploadedFiles.length > 0 && (
            <List divided relaxed className="uploadBox">
              {uploadedFiles.map((file) => (
                <List.Item key={file.id}>
                  <List.Content>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <List.Header
                        style={{
                          flex: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {file.name}
                      </List.Header>
                      <List.Description style={{ marginRight: "10px" }}>
                        {formatBytes(file.size)}
                      </List.Description>
                      {/* Action buttons */}
                      <Image
                        className="tableButton"
                        src="/images/grey-circle-close.svg"
                        alt="Close"
                        style={{ cursor: "pointer", marginRight: "5px" }}
                      />
                      <Image
                        className="tableButtonHover"
                        src="/images/red-circle-delete.svg"
                        alt="Remove"
                        onClick={() => onRemoveFile(file.id)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </List.Content>
                </List.Item>
              ))}
            </List>
          )}
        </div>
      </Card.Content>
      <Card.Content extra>
        <div
          className="dragBox"
          {...getRootProps()}
          style={dropzoneStyles}
        >
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Drop files here...</p>
          ) : (
            <>
              <div className="upload-button-div">
                <Image src="/images/blue-upload.svg" alt="Upload" />
                <div>Upload</div>
              </div>
              <p>or &nbsp;</p>
              <p>Drag and drop files here</p>
            </>
          )}
        </div>
        <p style={{ color: "#0000008f", marginTop: "5px" }}>
          {maxFileSizeMessage},&nbsp; {allowedFileTypesMessage}
        </p>
      </Card.Content>
    </Card>
  );
};

const formatBytes = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(k)));
  return Math.round(bytes / Math.pow(k, i)) + " " + sizes[i];
};

export default CustomFileUpload;